<div class="fm-rs-steps">

  <!-- Page Title -->
  <div class="fm-page-title">
    <h1 class="fm-head-24 fm-title">Create a New Memory</h1>
  </div>

  <!-- Step Header -->
  <div class="fm-rs-step-form">
    <div class="fm-step-wrapper">
      <div class="fm-white-column">
        <div class="fm-step-list">
          <div class="fm-step-item" [class.active]="currentStep() >= 1" [class.completed]="currentStep() > 1"
               (click)="currentStep() > 1 && goToStep(1)" role="button" tabindex="0" aria-label="Step 1">
            <div class="fm-step-icon">
              <img class="fm-svg" src="images/icons/fm-step1-icon.svg" alt="Step 1" />
            </div>
            <div class="fm-step-number">Step 01</div>
            <div class="fm-step-title">Choose Category</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 2" [class.completed]="currentStep() > 2"
               (click)="currentStep() > 2 && goToStep(2)" role="button" tabindex="0" aria-label="Step 2">
            <div class="fm-step-icon">
              <img class="fm-svg" src="images/icons/fm-step2-icon.svg" alt="Step 2" />
            </div>
            <div class="fm-step-number">Step 02</div>
            <div class="fm-step-title">Select Media Type</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 3" [class.completed]="currentStep() > 3"
               (click)="currentStep() > 3 && goToStep(3)" role="button" tabindex="0" aria-label="Step 3">
            <div class="fm-step-icon">
              <img class="fm-svg" src="images/icons/fm-step3-icon.svg" alt="Step 3" />
            </div>
            <div class="fm-step-number">Step 03</div>
            <div class="fm-step-title">Select Questions</div>
          </div>
          <div class="fm-step-item" [class.active]="currentStep() >= 4"
               role="button" tabindex="0" aria-label="Step 4">
            <div class="fm-step-icon">
              <img class="fm-svg" src="images/icons/fm-step4-icon.svg" alt="Step 4" />
            </div>
            <div class="fm-step-number">Step 04</div>
            <div class="fm-step-title">Answer Questions</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- STEP 1: Choose Category                                       -->
    <!-- ============================================================ -->
    @if (currentStep() === 1) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-section-title">
              <h2 class="fm-head-24">What Kind Of Memory Would You Like To Share?</h2>
              <p>Choose a category to get started with AI-powered prompts</p>
            </div>
            <div class="fm-category-grid">
              @for (cat of categories; track cat.id) {
                <div class="fm-category-box">
                  <input type="radio" name="memory" [id]="'cat-' + cat.id"
                         [checked]="selectedCategory() === cat.id"
                         (change)="selectCategory(cat.id)" />
                  <label class="fm-category-label" [for]="'cat-' + cat.id">
                    <div class="fm-check-icon">
                      <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                    </div>
                    <div class="fm-category-icon">
                      <img [src]="cat.icon" class="fm-svg" [alt]="cat.label" />
                    </div>
                    <h4 class="fm-head-22">{{ cat.label }}</h4>
                    <p>{{ cat.prompts }} prompts available</p>
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="fm-form-footer">
          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="cancelRecord()">
            Cancel
          </button>
          <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="nextStep()">
            Continue
            <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
          </button>
        </div>
      </div>
    }

    <!-- ============================================================ -->
    <!-- STEP 2: Select Media Type                                     -->
    <!-- ============================================================ -->
    @if (currentStep() === 2) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-compressed-cl">
              <div class="fm-section-title">
                <h2 class="fm-head-24">How Would You Like To Tell Your Story?</h2>
                <p>Choose the best way to capture your memories</p>
              </div>
              <div class="fm-media-list">
                @for (media of mediaTypes; track media.id) {
                  <div class="fm-media-card" [class.active]="selectedMedia() === media.id"
                       (click)="selectMedia(media.id)" role="button" tabindex="0">
                    <div class="fm-media-left">
                      <div class="fm-media-icon">
                        <img [src]="media.icon" class="fm-svg" [alt]="media.label" />
                      </div>
                      <div>
                        <h4 class="fm-head-22">{{ media.label }}</h4>
                        <p>{{ media.description }}</p>
                      </div>
                    </div>
                    <div class="fm-check-icon">
                      <img src="images/icons/fm-check.svg" class="fm-svg" alt="Selected" />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="fm-compressed-cl">
          <div class="fm-form-footer fm-space-between">
            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
              <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
              Back
            </button>
            <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="nextStep()">
              Continue
              <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
            </button>
          </div>
        </div>
      </div>
    }

    <!-- ============================================================ -->
    <!-- STEP 3: Select Questions                                      -->
    <!-- ============================================================ -->
    @if (currentStep() === 3) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="fm-white-column">
            <div class="fm-compressed-cl fm-large-cl">
              <div class="fm-section-title">
                <h2 class="fm-head-24">Select Questions</h2>
                <p>Choose which questions you want to answer</p>
              </div>
              <div class="fm-question-list">
                @for (q of questions(); track q.id; let i = $index) {
                  <div class="fm-question-card" [class.active]="q.selected">
                    <span class="fm-question-number">{{ (i + 1).toString().padStart(2, '0') }}</span>
                    <p class="mb-0 fm-question-text">{{ q.text }}</p>
                    <div class="fm-question-actions">
                      <button type="button" class="fm-question-menu-btn" (click)="deleteQuestion(q.id)" aria-label="Delete question">
                        <img src="images/icons/fm-delete.svg" class="fm-svg" alt="Delete" />
                      </button>
                    </div>
                    <div class="fm-check-icon" (click)="toggleQuestion(q.id)" role="button" tabindex="0">
                      <img src="images/icons/fm-check-white.svg" class="fm-svg" alt="Toggle" />
                    </div>
                  </div>
                }
              </div>

              <!-- Add Custom Question -->
              <div class="fm-add-question-btn">
                <button type="button" class="fm-common-btn" (click)="toggleCustomQuestion()">
                  <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Add" />
                  Add Your Own Questions
                </button>
              </div>
              @if (showCustomQuestion()) {
                <div class="fm-custom-question">
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="Type your question..."
                           [value]="customQuestionText()"
                           (input)="customQuestionText.set($any($event.target).value)" />
                    <button type="button" class="btn fm-icon-btn" (click)="saveCustomQuestion()" aria-label="Save question">
                      <img src="images/icons/fm-bookmark.svg" class="fm-svg" alt="Save" />
                    </button>
                    <button type="button" class="btn fm-icon-btn" (click)="toggleCustomQuestion()" aria-label="Cancel">
                      <img src="images/icons/fm-trash.svg" class="fm-svg" alt="Cancel" />
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="fm-compressed-cl fm-large-cl">
          <div class="fm-form-footer fm-space-between">
            <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
              <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
              Back
            </button>
            <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt"
                    [disabled]="selectedQuestions().length === 0" (click)="nextStep()">
              Continue
              <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
            </button>
          </div>
        </div>
      </div>
    }

    <!-- ============================================================ -->
    <!-- STEP 4: Answer Questions (Recording)                         -->
    <!-- ============================================================ -->
    @if (currentStep() === 4) {
      <div class="fm-step-content active">
        <div class="fm-card-wrapper">
          <div class="row g-4">

            <!-- Main Recording Area -->
            <div class="col-lg-8">
              <div class="fm-recording-wrapper">

                <!-- Progress -->
                <div class="fm-progress-wrapper">
                  <p class="fm-que-txt">Question {{ currentQuestionIndex() + 1 }} of {{ selectedQuestions().length }}</p>
                  <p class="fm-pcompleted-count">{{ progressPercent() }}% Completed</p>
                </div>
                <div class="progress fm-progress-bar">
                  <div class="progress-bar" [style.width.%]="progressPercent()"></div>
                </div>

                <!-- Current Question -->
                <div class="fm-question-box">
                  <p class="mb-2">Question {{ currentQuestionIndex() + 1 }}</p>
                  <h4 class="fm-head-20">{{ currentQuestion()?.text }}</h4>
                </div>

                <!-- Video Recording -->
                @if (selectedMedia() === 'video') {
                  <div class="fm-video-box">
                    <div class="fm-video-preview" data-recording-state="idle">
                      <div class="fm-video-icon">
                        <img src="images/icons/fm-video-lg.svg" class="fm-svg" alt="Video" />
                      </div>
                    </div>
                    <div class="fm-video-btn">
                      <div class="row g-3 g-xl-4">
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100">
                            <img src="images/icons/fm-record.svg" class="fm-svg" alt="Record" />
                            Record Video
                          </button>
                        </div>
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-large-btn w-100">
                            <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload" />
                            Upload Video
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <!-- Audio Recording -->
                @if (selectedMedia() === 'audio') {
                  <div class="fm-audio-box">
                    <div class="fm-audio-preview" data-recording-state="idle">
                      <div class="fm-audio-icon">
                        <img src="images/icons/fm-micro-icon.svg" class="fm-svg" alt="Audio" />
                      </div>
                      <div class="fm-audio-waveform mt-3" aria-hidden="true">
                        <img src="images/icons/fm-audio-wave.svg" class="fm-audio-wave-img" alt="Wave" />
                      </div>
                    </div>
                    <div class="fm-audio-btn">
                      <div class="row g-3 g-xl-4">
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100">
                            <img src="images/icons/fm-record.svg" class="fm-svg" alt="Record" />
                            Record Audio
                          </button>
                        </div>
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-large-btn w-100">
                            <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload" />
                            Upload Audio
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <!-- Image + Audio -->
                @if (selectedMedia() === 'image-audio') {
                  <div class="fm-audio-box">
                    <div class="fm-audio-preview" data-recording-state="idle">
                      <label for="fmImageAudioInput" class="fm-audio-icon fm-audio-upload-label" style="cursor:pointer">
                        <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload Photo" />
                      </label>
                      <p class="mb-0 mt-2">Drop your photo here, or <span class="fm-browse-link">Browse</span></p>
                      <input type="file" id="fmImageAudioInput" class="d-none" accept="image/*" />
                      <div class="fm-audio-waveform mt-3" aria-hidden="true">
                        <img src="images/icons/fm-audio-wave.svg" class="fm-audio-wave-img" alt="Wave" />
                      </div>
                    </div>
                    <div class="fm-audio-btn">
                      <div class="row g-3 g-xl-4">
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-record-btn fm-large-btn w-100">
                            <img src="images/icons/fm-record.svg" class="fm-svg" alt="Record" />
                            Record Audio
                          </button>
                        </div>
                        <div class="col-sm-6">
                          <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn fm-large-btn w-100">
                            <img src="images/icons/fm-upload.svg" class="fm-svg" alt="Upload" />
                            Upload Audio
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                <!-- Footer Nav -->
                <div class="fm-form-footer fm-space-between">
                  <button type="button" class="fm-common-btn fm-secondary-btn fm-secondary-border-btn" (click)="prevStep()">
                    <img src="images/icons/fm-arrow-left.svg" class="fm-svg" alt="Back" />
                    Back
                  </button>
                  @if (!isLastQuestion()) {
                    <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="nextQuestion()">
                      Next Question
                      <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Next" />
                    </button>
                  } @else {
                    <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt" (click)="finishAndReview()">
                      Finish &amp; Review
                      <img src="images/icons/fm-arrow-right.svg" class="fm-svg" alt="Finish" />
                    </button>
                  }
                </div>
              </div>
            </div>

            <!-- Sidebar: Questions List + Tips -->
            <div class="col-lg-4">
              <div class="row g-4">

                <!-- Questions List -->
                <div class="col-12 col-sm-6 col-lg-12">
                  <div class="fm-sidebar-card">
                    <div class="fm-sidebar-title">
                      <span class="fm-head-20">Questions List</span>
                    </div>
                    <div class="fm-question-list">
                      @for (q of selectedQuestions(); track q.id; let i = $index) {
                        <div class="fm-question-card" [class.active]="i === currentQuestionIndex()">
                          <span class="fm-question-number">{{ (i + 1).toString().padStart(2, '0') }}</span>
                          <p class="mb-0 fm-question-text">{{ q.text }}</p>
                          <div class="fm-check-icon">
                            <img src="images/icons/fm-check-white.svg" class="fm-svg" alt="Active" />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>

                <!-- Recording Tips -->
                <div class="col-12 col-sm-6 col-lg-12">
                  <div class="fm-sidebar-card">
                    <div class="fm-sidebar-title">
                      <h5 class="fm-head-20">Recording Tips</h5>
                    </div>
                    <hr class="w-100" />
                    <div class="fm-recording-tips-list">
                      <div class="fm-detail-item">
                        <div class="fm-detail-icon">
                          <img class="fm-svg" src="images/icons/fm-speak-sm.svg" alt="Tip" />
                        </div>
                        <div class="fm-detail-content">
                          <p class="fm-detail-text">Speak naturally, as if talking to a friend</p>
                        </div>
                      </div>
                      <div class="fm-detail-item">
                        <div class="fm-detail-icon">
                          <img class="fm-svg" src="images/icons/fm-clock-sm.svg" alt="Tip" />
                        </div>
                        <div class="fm-detail-content">
                          <p class="fm-detail-text">Take your time &amp; pause when needed</p>
                        </div>
                      </div>
                      <div class="fm-detail-item">
                        <div class="fm-detail-icon">
                          <img class="fm-svg" src="images/icons/fm-check-sm.svg" alt="Tip" />
                        </div>
                        <div class="fm-detail-content">
                          <p class="fm-detail-text">Include specific details and emotions</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    }

  </div>
</div>
